import { Routes, RouterModule } from "@angular/router";

export const TWO_COLUMN_ROUTES: Routes = [
  {
    path: "2-columns-layout",
    loadChildren:
      "./pages/2-columns-layout-page/2-columns-layout-page.module#TwoColumnsLayoutPagesModule",
  },
  {
    path: "dashboard",
    loadChildren: "./dashboard/dashboard.module#DashboardModule",
  },
  {
    path: "home",
    loadChildren: "./home/home.component.module#HomeModule",
  },
  {
    path: "role-program-link",
    loadChildren: "./role-program-link/role-program-module#RoleProgramModule",
  },
  {
    path: "role",
    loadChildren: "./role/role-module#RoleModule",
  },
  {
    path: "components",
    loadChildren: "./components/ui-components.module#UIComponentsModule",
  },
  {
    path: "customer-type",
    loadChildren: "./customer-type/customer-type.module#CustomerTypeModule",
  },
  {
    path: "ticket-type",
    loadChildren: "./ticket-type/ticket-type.component.module#TicketTypeModule",
  },
  {
    path: "agency-list",
    loadChildren:
      "./agency-creation/agency-creation.component.module#AgencyCreationModule",
  },
  {
    path: "agency-creation",
    loadChildren:
      "./agency-master/agency-master.component.module#AgencyMasterModule",
  },
  {
    path: "payment",
    loadChildren: "./payment/payment.component.module#PaymentModule",
  },
  // {
  //     path: 'attraction',
  //     loadChildren: './attractive/attractive.component.module#AttractiveModule'
  // },
  {
    path: "attraction-booking",
    loadChildren: "./booking/booking.component.module#BookingModule",
  },
  {
    path: "ticket-view",
    loadChildren:
      "./ticket-inventory/ticket-inventory.module#TicketInventoryModule",
  },
  {
    path: "yacht-delete-view",
    loadChildren:
      "./delete-inventory/delete-inventory.module#DeleteInventoryModule",
  },
  {
    path: "ticket-inventory",
    loadChildren: "./inventory-view/inventory-view.module#InventoryViewModule",
  },

  {
    path: "yacht-remove",
    loadChildren: "./inventory-view/inventory-view.module#InventoryViewModule",
  },
  {
    path: "markup",
    loadChildren: "./markup/markup.component.module#MarkupModule",
  },
  {
    path: "park-view",
    loadChildren: "./park-view/park-view.component.module#ParkViewModule",
  },
  {
    path: "park-creation",
    loadChildren:
      "./park-creation/park-creation.component.module#ParkCreationModule",
  },
  {
    path: "paylink",
    loadChildren: "./paylink/paylink.module#PaylinkModule",
  },
  {
    path: "itnery",
    loadChildren: "./itnery/itnery.module#ItneryModule",
  },
  {
    path: "payatCounteritnery",
    loadChildren:
      "./payat-counter-itenary/payat-counteritenary.module#PayatCounteritenaryModule",
  },
  {
    path: "sales",
    loadChildren: "./sales-report/sales-report.module#SalesReportModule",
  },
  {
    path: "agent-sales",
    loadChildren:
      "./agent-sales-report/agent-sales-report.module#AgentSalesReportModule",
  },
  {
    path: "passenger",
    loadChildren: "./passenger-type/passenger-type.module#PassengerTypeModule",
  },
  {
    path: "stock",
    loadChildren: "./stock/stock.module#StockModule",
  },
  {
    path: "inventory",
    loadChildren: "./inventory/inventory.module#InventoryModule",
  },
  {
    path: "cancellation",
    loadChildren: "./cancellation/cancellation.module#CancellationModule",
  },
  {
    path: "bookingreport",
    loadChildren: "./booking-report/booking-report.module#BookingReportModule",
  },
  {
    path: "ticketcancelreport",
    loadChildren:
      "./ticketcancel-report/ticketcancel-report.component.module#TicketCancelReportModule",
  },
  {
    path: "statementreport",
    loadChildren:
      "./statement-report/statement-report.module#StatementReportModule",
  },
  {
    path: "monthlyreport",
    loadChildren: "./monthly-reports/monthly-report.module#MonthlyReportModule",
  },
  {
    path: "payat-counter-report",
    loadChildren:
      "./pay-at-counter-reporter/pay-at-counter.module#PayAtCounterModule",
  },
  {
    path: "boarding-report",
    loadChildren: "./board-reports/board-reports.module#BoardReportsModule",
  },
  {
    path: "city",
    loadChildren: "./city-master/city-master.module#CityMasterModule",
  },
  {
    path: "grouping",
    loadChildren:
      "./grouping-master/grouping-master.module#GroupingMasterModule",
  },
  {
    path: "return-tkts",
    loadChildren: "./unsold-tkts/unsold-tkts.component.module#UnsoldTktsModule",
  },
  {
    path: "parks",
    loadChildren: "./grouped-parks/grouped-parks.module#GroupedParksModule",
  },
  {
    path: "online-payment",
    loadChildren:
      "./online-payment/online-payment.component.module#OnlinePaymentModule",
  },
  {
    path: "payment-failed",
    loadChildren: "./payment-fail/payment-fail.module#PaymentFailModule",
  },
  // {
  //     path: 'category-creation',
  //     loadChildren: './attractive/attractive.component.module#AttractiveModule'
  // },
  {
    path: "attractions",
    loadChildren: "./attractive/attractive.component.module#AttractiveModule",
  },
  {
    path: "attraction",
    loadChildren: "./category-group/category-group.module#CategoryGroupModule",
  },
  {
    path: "park-category",
    loadChildren:
      "./category-master/category-master.module#CategoryMasterModule",
  },
  {
    path: "inventory-grouping",
    loadChildren: "./yatch-grouping/yatch-grouping.module#YatchGroupingModule",
  },
  {
    path: "inventory-grouping-creation",
    loadChildren:
      "./yatch-grouping-creation/yatch-grouping-creation.module#YatchGroupingCreationModule",
  },
  {
    path: "inventory-ticket-creation",
    loadChildren:
      "./inventory-creation/invetory-creation.module#InvetoryCreationModule",
  },

  {
    path: "agent-credit-report",
    loadChildren:
      "./agent-credit-details-report/agent-credit-details.module#AgentCreditDetailsModule",
  },
  {
    path: "payment-reports",
    loadChildren:
      "./payment-reports/payment-reports.module#PaymentReportsModule",
  },
];



// WEBPACK FOOTER //
// ./src/app/shared/routes/2-columns-layout.routes.ts